import React, { useState } from "react";
import MenuIcon from "../../../../../assets/disabilityIcons/Menu.svg";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const Assets = ["Investment", "Physical"];
const Loan = ["Credit", "Liability"];
const Income = [
  "Self - Employment",
  "Earned Income from Work",
  "Military Benefits",
  "Pension",
  "Distribution from Asset",
  "Insurance Payout",
  "Settlement (Structured & Lump)",
  "Alimony",
  "Annuity Non-Investment Income",
  "Disability Income Payments",
  "Reverse Mortgage",
  "Social Security",
  "Real Estate Rental",
  "RMD Distribution",
  "Other Income",
];

export default function ActionColumnComponent({ viewModal, updateModal, deleteRecord }) {
  const [dropdown, setDropdown] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const history = useHistory();

  const getSelectedRow = (id) => {
    setSelectedIndex(id);
  };

  return {
    title: "Action",
    key: "action",
    render: (record, index) => (
      <div style={{ display: "flex" }} key={index}>
        <div
          onClick={() => {
            getSelectedRow(record.id);
            setDropdown(!dropdown);
          }}
          style={{
            cursor: "pointer",
            marginRight: "1rem",
            padding: "6px 16px",
            width: "5px",
          }}
        >
          <img src={MenuIcon} style={{ rotate: "90deg" }} alt="menuIcon" />
        </div>
        {dropdown && selectedIndex === record.id && (
          <>
            <div
              onClick={() => setDropdown(false)}
              style={{
                position: "fixed",
                width: "100vw",
                height: "100vh",
                background: "black",
                opacity: "0.1",
                top: "0",
                left: "0",
                right: "0",
                bottom: "0",
                zIndex: "999",
              }}
            />
            <div className="dropdown" style={{ zIndex: "9999" }}>
              <ul className="dropdownul">
                <li
                  className="liHover"
                  onClick={() => {
                    setDropdown(false);
                    if (Assets.includes(record.subType)) {
                      return;
                    } else if (Loan.includes(record.subType)) {
                      return;
                    } else if (Income.includes(record.module)) {
                      return;
                    }
                    viewModal(record);
                    console.log("monitoring", record);
                  }}
                >
                  View
                </li>
                <li
                  className="liHover"
                  onClick={() => {
                    setDropdown(false);
                    if (Assets.includes(record.subType)) {
                      history.push(`/assets_new/attributes/${record.module}/${record.id}`);
                    } else if (Loan.includes(record.subType)) {
                      history.push(`/liabilities_credit_new/attributes/${record.module}/${record.id}`);
                    } else if (Income.includes(record.module)) {
                      history.push(`/income_new/attributes/${record.module}/${record.id}`);
                    }
                    updateModal(record);
                    console.log("monitoring", record.module);
                  }}
                >
                  Update
                </li>
                <li
                  className="liHover"
                  onClick={() => {
                    deleteRecord(record);
                    setDropdown(false);
                    console.log("monitoring", record.module);
                  }}
                >
                  Delete
                </li>
              </ul>
            </div>
          </>
        )}
      </div>
    ),
  };
}
